import api from "./api";

const RESOURCE = "/api/pessoa/pf";
const RESOURCE_PERSON = "/api/pessoa";

const Person = {
  listData: async (id) => await api.get(RESOURCE + `/${id}`),
  integrationPerson: async (cpfCnpj) =>
    await api.get(RESOURCE_PERSON + `/integration/cpfCnpj/${cpfCnpj}`),
};

export default Person;
